var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"absolute top-0 left-0 w-full h-full",attrs:{"basic-loading":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }